export default __webpack_public_path__ + "static/media/lvv.61f2fbdd.webp";